import React from 'react';
import Select from 'react-select';
import _ from 'lodash';
import Constants from '../../config/constants';

export default class PaginateSelect extends React.Component {
  static TYPE_NAME = 'pagination-select';
  constructor(props) {
    super(props);
    this.state = {
      options: props.options,
      isLoading: false,
      searchValue: '',

      value: props.value,
      selectedOption: undefined,
    };
    this.loadOptions = _.debounce(this.loadOptions, Constants.DEBOUNCE_TIME);
  }

  componentDidMount() {
    this.loadOptions('', false, 'initial');
    this.updateSelectedOption(this.state.value);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.updateSelectedOption(nextProps.value && nextProps.value.value);
    }
  }

  render() {
    return (
      <Select
        placeholder={this.props.placeholder}
        menuPlacement={this.props.menuPlacement}
        isDisabled={this.props.isDisabled || this.props.disabled}
        isClearable={!this.props.required && !this.props.isDisabled && !this.props.disabled}
        value={this.state.selectedOption}
        options={this.state.options}
        isLoading={this.state.isLoading}
        onMenuScrollToBottom={() => this.loadOptions(this.state.searchValue, false, 'scroll')}
        onInputChange={(searchValue, { action }) => this.loadOptions(searchValue, true, action)}
        onChange={(rawValue, { action }) => this.onValueChanged(rawValue, action)}
        className={this.props.className}
        classNamePrefix={this.props.classNamePrefix}
      />
    );
  }

  updateSelectedOption(value) {
    // value is not store as object
    const filteredOptions = this.state.options.filter(option => option.value === value);
    const selectedOption = filteredOptions.pop() || null;
    this.setState({ selectedOption });
  }

  onValueChanged(rawValue, action) {
    let value;
    if (action === 'select-option') {
      value = rawValue;
    } else if (['pop-option', 'remove-value', 'create-option', 'clear'].some(action_type => action === action_type)) {
      value = null;
    }

    this.updateSelectedOption(value && value.value);
    this.props.onChange(value);

    // if (this.shouldValueChanged(value.value)) {
    //   this.updateSelectedOption(value.value);
    //   this.setState({ value: value.value }, () => {
    //     this.props.onChange(value);
    //   });
    // }
  }

  shouldValueChanged(value) {
    // If required
    // Prevent user from removes the selected option
    if (this.props.required && !value) {
      return false;
    }
    return true;
  }

  onOptionsLoaded(options) {
    let validOptions = this.mergeOptions(options);

    this.setState(
      prevState => ({
        ...prevState,
        options: validOptions,
      }),
      () => {
        // If required is true and no value is set,
        // Select the first option
        if (this.props.required && !this.state.value && this.state.options.length > 0) {
          this.onValueChanged(this.state.options[0].value, 'select-option');
        }
      });
  }

  mergeOptions(options) {
    let validOptions = [...this.state.options];
    let addedOptions = new Set(validOptions.map(option => option.value));

    options = options.filter(option => !addedOptions.has(option.value));

    return [...validOptions, ...options];
  }

  loadOptions(searchValue = '', clearOptions = false, action) {
    action = String(action);
    if (this.state.isLoading || !(action === 'initial' || action === 'scroll' || action === 'input-change')) return;

    this.setState({
      isLoading: true,
      searchValue,
    });

    if (clearOptions) {
      this.setState({ options: [] });
    }

    const page = Math.floor(this.state.options.length / this.props.pageSize);
    Promise.resolve()
      .then(() => this.props.loadOptions(searchValue, page))
      .then(options => this.onOptionsLoaded(options))
      .catch(err => null)
      .then(() => this.setState({ isLoading: false }))
  }
}

PaginateSelect.defaultProps = {
  required: false,
  onChange: () => {},
  value: null,
  options: [],
  loadOptions: (searchValue, page) => [],
  menuPlacement: 'bottom',
  pageSize: 10,
  isDisabled: false,
  placeholder: 'selection',
};
// Sample
//
// const provinceOptions = province_id ? [
//   { value: province_id, label: province_name },
// ] : [];
// const loadOptions = (searchValue, page) => {
//   return listProvince(10, page, searchValue).payload
//     .then(options => options.map(option => ({value: option.id, label: option.name})))
//     .catch(() => {})
// };
//
// <FieldGroup
//   id="project-province"
//   componentClass={PaginateSelect.TYPE_NAME}
//   field="province_id"
//   label={t('province')}
//   value={province_id}
//   defaultDirty={true}
//   loadOptions={loadOptions}
//   required={true}
//   options={provinceOptions}
// />



// WEBPACK FOOTER //
// ./src/components/field_group/PaginateSelect.js